export const passwordTooltipText =
    'Passwords require: at least 8 characters, a number, a special character, an uppercase letter and a lowercase letter.';
